import getCbtClient, { cbtResponse } from "../cbtClient";

interface IPassengerNotificationFrontendListRequestBody {
  Destination: string;
  Users: Array<string>;
  AdditionalUsers:
    | Array<{
        FirstName: string;
        LastName: string;
        Citizenship: string;
      }>
    | [];
  Connector: "Flight" | "Hotel";
  AirCompanies: string[];
}

interface CBTConnectionData {
  cbtApiUrl: string;
  customerUsername: string;
  cbtToken: string;
}

export interface ResponseData {
  FirstName: string;
  LastName: string;
  Message: string;
  UserId?: string;
}

const fetchPassengerNotification = async (
  cbt,
  cbtConnectionData: CBTConnectionData,
  destination: string,
  connector: "Flight" | "Hotel",
  marketingAirlines: string[] = []
): Promise<ResponseData[]> => {
  const reqBody: IPassengerNotificationFrontendListRequestBody = {
    Destination: destination,
    Users: cbt.passengersForm.travellers,
    AdditionalUsers: [],
    Connector: connector,
    AirCompanies: marketingAirlines,
  };

  const cbtClient = await getCbtClient(cbtConnectionData);

  const response = await cbtResponse(
    cbtClient.post(`/passenger-notifications`, reqBody)
  );

  const data: ResponseData[] = response.success ? response.data : [];

  return data;
};

export default fetchPassengerNotification;
